/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { SearchResultItem } from './SearchResultItem.js';
import {
    SearchResultItemFromJSON,
    SearchResultItemFromJSONTyped,
    SearchResultItemToJSON,
} from './SearchResultItem.js';

/**
 * 
 * @export
 * @interface TestSearchResponse
 */
export interface TestSearchResponse {
    /**
     * 
     * @type {Array<SearchResultItem>}
     * @memberof TestSearchResponse
     */
    data?: Array<SearchResultItem>;
    /**
     * 
     * @type {number}
     * @memberof TestSearchResponse
     */
    totalRecords?: number;
    /**
     * 
     * @type {number}
     * @memberof TestSearchResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof TestSearchResponse
     */
    pages?: number;
    /**
     * 
     * @type {Array<Error>}
     * @memberof TestSearchResponse
     */
    errors?: Array<Error>;
}

/**
 * Check if a given object implements the TestSearchResponse interface.
 */
export function instanceOfTestSearchResponse(value: object): boolean {
    return true;
}

export function TestSearchResponseFromJSON(json: any): TestSearchResponse {
    return TestSearchResponseFromJSONTyped(json, false);
}

export function TestSearchResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TestSearchResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(SearchResultItemFromJSON)),
        'totalRecords': json['totalRecords'] == null ? undefined : json['totalRecords'],
        'page': json['page'] == null ? undefined : json['page'],
        'pages': json['pages'] == null ? undefined : json['pages'],
        'errors': json['errors'] == null ? undefined : json['errors'],
    };
}

export function TestSearchResponseToJSON(value?: TestSearchResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(SearchResultItemToJSON)),
        'totalRecords': value['totalRecords'],
        'page': value['page'],
        'pages': value['pages'],
        'errors': value['errors'],
    };
}

